import { useOutletContext } from "react-router-dom";
import "./LakeConditions.css"
import StationChart from "./StationChart";
import { TercAPI } from "../../js/terc_api";
import MODULES from "../../static/modules.json";
import { parse_time_range } from "../../js/util";
import TimePlot from "./TimePlot";


function Algae(props) {
    const [_, module_container] = useOutletContext();

    const tab_index = module_container.tab_index;
    const bottom_tab_index = module_container.bottom_tab_index;
    const [chart_start_date, chart_end_date] = 
        parse_time_range(
            Object.values(MODULES.LAKE_CONDITIONS.TABS)[tab_index]
            .BOTTOM_TABS[bottom_tab_index]
            .time_range
        );    


    const children = (station_data) => {
        const chart_props = {
            "y_label": "ALGAE (RELATIVE)",
            "y_ticks": 7,
            "y_padding": 25
        };
        let time = station_data.map(x => x[TercAPI.TIME_NAME]);
        let algae = station_data.map(x => x[TercAPI.ALGAE_NAME]);
        return <TimePlot
            time={time}
            y={algae}
            {...chart_props}
            />
    };

    return (
        <StationChart
            marker_data_type={TercAPI.ALGAE_NAME}
            children={children}
            start_date={chart_start_date}
            end_date={chart_end_date}
            />
    );
}

export default Algae;